<template>
  <div id="index">
    <mHeader ref="mHeader"></mHeader> 
    <div style="width:100%;height:44px"></div>
    <!-- 推荐产品 -->
    <div class="mNewsDetails">
      <h4>{{newsDetails.articleTitle}}</h4>
      <h6>{{newsDetails.createTime}}</h6>
      <p v-html="newsDetails.articleContentString">{{newsDetails.articleContentString}}</p>
      <img :src="newsDetails.headImg" alt="">
    </div>
  </div>
</template>
<script>
import mHeader from '../../components/mobile/mHeader'
export default {
  components: {
    mHeader
  },
  data() {
    return {
      newsDetails:{},
    }
  },
  mounted() {
    this.getArticleDetails();
  },
  methods: {
    getArticleDetails(){
      this.$fetch('getArticleDetails',{id:this.$route.query.id}).then(res => {
       this.newsDetails = res.result
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mobile/mNewsDetails.vue